import React from 'react'
import { IntrigrationSec } from './intrigrationSec'

export const IntrigrationVaultDeleteCard = () => {
  return (
    <>
    <IntrigrationSec /> 
    </>
  )
}
